// extracted by mini-css-extract-plugin
module.exports = {"NewsSearch":"NewsSearch_NewsSearch__39qTj"};